// ReportLab registers server-side font paths; browser previews need public TTF URLs.
// Keep the original HTML untouched for the server PDF converter.
export const browserPrintHtml = html => String(html || "")
  .replaceAll("/usr/share/fonts/truetype/noto/NotoSans-Regular.ttf", "/fonts/NotoSans-Regular.ttf")
  .replaceAll("/usr/share/fonts/truetype/noto/NotoSans-Bold.ttf", "/fonts/NotoSans-Bold.ttf")
  .replaceAll("/app/backend/assets/fonts/ZenMono-Regular.ttf", "/fonts/ZenMono-Regular.ttf")
  .replaceAll("/app/backend/assets/fonts/ZenMono-Bold.ttf", "/fonts/ZenMono-Bold.ttf");